import logo from './logo.svg';
import './App.css';
import React, { createContext, useState, useEffect, Component } from "react";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./ScrollToTop.jsx";

// Import Components
import Home from './components/home/home';
import QuienesSomos from './components/quienesSomos/quienesSomos'
import Soluciones from './components/soluciones/soluciones'
import Tecnologia from './components/tecnologia/tecnologia'
import Contactanos from './components/contactanos/contactanos'
import GalerieTechComponet from './components/GalerieTechComponet/galerieTechComponent'


// Import Assets
import photoSoluciones1 from './assets/homeAssets/photo-soluciones/photo-soluciones-1.jpg';
import photoSoluciones2 from './assets/homeAssets/photo-soluciones/photo-soluciones-2.jpg';
import photoSoluciones3 from './assets/homeAssets/photo-soluciones/photo-soluciones-3.jpg';
import photoSoluciones4 from './assets/homeAssets/photo-soluciones/photo-soluciones-4.jpg';
import photoSoluciones5 from './assets/homeAssets/photo-soluciones/photo-soluciones-5.jpg';
import photoSoluciones6 from './assets/homeAssets/photo-soluciones/photo-soluciones-6.jpg';
import photoSoluciones7 from './assets/homeAssets/photo-soluciones/photo-soluciones-7.jpg';
import photoSoluciones8 from './assets/homeAssets/photo-soluciones/photo-soluciones-8.jpg';



// Import Assets Pproduct Tech
import ProductTech1 from './assets/tecnologiaAssets/CamarasAnalogas/C-Analoga1.jpg'
import ProductTech2 from './assets/tecnologiaAssets/CamarasAnalogas/C-Analoga2.jpg'
import ProductTech3 from './assets/tecnologiaAssets/CamarasAnalogas/C-Analoga3.jpg'
import ProductTech4 from './assets/tecnologiaAssets/CamarasIP/C-IP1.jpg'
import ProductTech5 from './assets/tecnologiaAssets/CamarasIP/C-IP2.jpg'
import ProductTech6 from './assets/tecnologiaAssets/CamarasIP/C-IP3.jpg'
import ProductTech7 from './assets/tecnologiaAssets/CamarasInteligentes/C-Intel1.jpg'
import ProductTech8 from './assets/tecnologiaAssets/CamarasInteligentes/C-Intel2.jpg'
import ProductTech9 from './assets/tecnologiaAssets/CamarasInteligentes/C-Intel3.jpg'


//Title Soluciones
const titleSolucion1 = ( <> GUARDIANÍA VIRTUAL CON ALERTA EN TIEMPO REAL</>);
const titleSolucion2 = ( <> VÍDEO VIGILANCIA INTELIGENTE </>);
const titleSolucion3 = ( <> ALARMAS INTELIGENTES AUTOMATIZADAS </>);
const titleSolucion4 = ( <> SALA DE MONITOREO <br/> ACTIVO 24/7 </>);
const titleSolucion5 = ( <> CONTROLES DE ACCESO VEHICULAR </>);
const titleSolucion6 = ( <> CONTROLES DE ACCESO PEATONAL </>);
const titleSolucion7 = ( <> CABLEADO ESTRUCTURADO </>);
const titleSolucion8 = ( <> SEGURIDAD <br/> PERIMETRAL </>);


//Text Soluciones
const textSolucion1 = "Guardianía virtual con asistencia remota y alerta en tiempo real directo a tu teléfono móvil 24/7. Ahorra en costos de vigilancia sin limitaciones en seguridad y protección.";
const textSolucion2 = "Ofrecemos equipos de vídeo vigilancia con sistemas inteligentes de reconocimiento facial, detector de movimiento, audio escucha y mucho más.";
const textSolucion3 = "Contamos con alarmas inteligentes con vídeo verificación, alerta en tiempo real y monitoreo activo automatizado.";
const textSolucion4 = "Contamos con una central de vigilancia y monitoreo con personal capacitado y un sistema inteligente de alerta en tiempo real que garantiza una asistencia inmediata";
const textSolucion5 = "Ofrecemos soluciones para control vehicular con equipos y sistemas de última generación, barreras inteligentes, vídeo verificación y más. Asistencia y servicio técnico.";
const textSolucion6 = "Ofrecemos soluciones para control de acceso peatonal con equipos biométricos, sensores de reconocimiento facial, ocular, dactilar entre otros. Instalación, asistencia y servicio técnico.";
const textSolucion7 = "Brindamos soluciones en cableado estrucurado, redes de teléfonia para contact center, centrales teléfonicas internas, redes de internet de fibra optica y más.";
const textSolucion8 = "Contamos con soluciones anti robo, vallas electrificadas, cirenas, vídeo porteros con vídeo verificación, sensores de movimiento con alerta en tiempo real.";



// Props Menu Bar Scroll Page
const linkUrl = ['/', '/quienes-somos', '/soluciones', '/tecnologia', '/contactanos'];
const nameClass = ['Home', 'quienes-somos', 'soluciones', 'tecnologia', 'contactanos'];
const namePage = ['HOME', 'QUIENES SOMOS', 'SOLUCIONES', 'TECNOLOGÍA', 'CONTÁCTANOS'];


// Props Page Tecnología 
 const bkGallerieTech = [
  
  ProductTech1, ProductTech2, ProductTech3, 
  ProductTech4, ProductTech5, ProductTech6, 
  ProductTech7, ProductTech8, ProductTech9 ];


const productTech = [

  // Product Tech 1
  {
    titleSectionTech: 'SISTEMA DE VIGILANCIA CCTV ANÁLOGOS CON DVR',
    textInfoTech: 'Ofrecemos soluciones de alta calidad y rendimiento al mejor precio del mercado. Contamos con equipos HD, HDCVI con imagen full color para día y noche, equipos lentes bifocales motorizados con zoom para enfoque remoto desde un teléfono móvil, equipos resistentes al agua y polvo para uso en exteriores, grabadoras centrales DVR con gran capacidad de almacenamiento y protección de datos.',
    titlePanel: [ 'Bullet ColorVu (DS-2CE10DF0T)', 'Domo Eyeball (HAC-HDW1200T-Z)', 'DVR (Digital Video Recorder)'],
    textInfoPanel: [
      'Caranterísticas: Color las 24 Horas, Luz LED Integrada, Resistencia a agua y polvo (IP67), Resolución:	2 Megapíxeles (1080p Full HD), Visión Nocturna: Hasta 20 metros a todo color.',
      'Cámara flexible con zoom motorizado, su lente focal motorizado permite ajutar el ángulo de vision de forma remota. Calidad de imagen full HD, visión nocturna inteligente.',
      'Grabadores DVR con tecnología H.265+, graba en alta definición en formato comprimido sin perder calidad. Acceso remoto total con Hik Connect. Compatibilidad total, permite conectar cámaras análogas de multiples tecnologías.'
      ]
    
  },


  // Product Tech 2
  {
    titleSectionTech: 'SISTEMAS DE VIGILANCIA IP',
    textInfoTech: 'Monitronix SAS te ofrece una amplia gama de equipos de videovigilancia con tecnología IP para diversos requerimientos. Contamos con equipos capaces de girar 360° y dar seguimiento inteligente a objetivos en movimiento, equipos con visión nocturna, sirena y luz estroboscópica. La tecnología IP permite la comunicación de la cámara hacia una central de monitoreo sin la necesidad de una conexión alámbrica fija.',
    titlePanel: [ 'Serie C6N (Smart Wi-Fi)', 'H8c (Exterior Wi-Fi)', 'Serie Lite IP (IPC-HFW2231S)'],
    textInfoPanel: [
      'Es la solución perfecta para el hogar o pequeñas oficinas con visión 360° que puede girar con una aplicación gratuita desde su celular',
      'Cámara "todo en uno", ideal para protección de perímetros. Combina visión 360°, defensa activa, sirena y luz de emergencia. Capacidad para detectar personas con IA, alta resistencia al sol, lluvia y polvo.',
      'Cámara tipo "bullet" (bala) que destaca por su calidad de imagen superior en conficiones de luz baja gracias a su tecnología Starlight. Perfecta para vigilancia en entornos oscuros o nocturnos.'
    ]
  },


  // Product Tech 3
  {
    titleSectionTech: 'SISTEMAS DE VIGILANCIA INTELIGENTES',
    textInfoTech: 'Contamos con soluciones tecnológicas avanzadas en vídeo vigilancia con iteligencia artifical. Cámaras con reconocimiento facial mediante Deep Learning, análisis de vídeo, capacidad para diferenciar personas, vehículos o animales. Detección de movimiento avanzado y alerta de actividad inusual con disuasión activa.',
    titlePanel: [ 'Hikvision AcuSense Gen2', 'Dahua TiOC (Seguridad Inteligente 3 en 1)', 'Térmica / Bi-Spectrum'],
    textInfoPanel: [
      'Perfecta para el control de perimetros sin errores, alta precisión de reconocimiento de objetos en movimiento. Ignora lluvia, animales u otros. Envía alertas solo cuando detecta vehículos y personas.',
      'Otorga vídeo full color en alta definición 24/7. Detecta y diferencia vehículos o personas con IA. Visión nocturna, disuasión activa, audio bidireccional y más.',
      'Nivel máximo de tecnología con sistema Bi-Spectrum de visión dual. Combina lente óptico con sensor térmico, detecta el calor corporal, alerta temprana de incendios, ofrece protección perimetral de largo alcance.'
    ]

  },


]



// Provider Context
export const AppContext = createContext();


export default function App() {

  return (

  <AppContext.Provider value={{ 

      // Photo Soluciones
      photoSoluciones1,
      photoSoluciones2,
      photoSoluciones3,
      photoSoluciones4,
      photoSoluciones5,
      photoSoluciones6,
      photoSoluciones7,
      photoSoluciones8,
      // Title Soluciones
      titleSolucion1,
      titleSolucion2,
      titleSolucion3,
      titleSolucion4,
      titleSolucion5,
      titleSolucion6,
      titleSolucion7,
      titleSolucion8,
      // Text Soluciones
      textSolucion1,
      textSolucion2,
      textSolucion3,
      textSolucion4,
      textSolucion5,
      textSolucion6,
      textSolucion7,
      textSolucion8,
      // Props Menu Bar Scroll Page
      linkUrl,
      nameClass,
      namePage,
      // Props Page Tecnología 
      bkGallerieTech,
      productTech

      }}>

      <HelmetProvider>
        <div className="App">
                <BrowserRouter>
                <ScrollToTop />
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/quienes-somos" element={<QuienesSomos />} />
                    <Route path="/soluciones" element={<Soluciones />} />
                    <Route path="/tecnologia" element={<Tecnologia />} />
                    <Route path="/contactanos" element={<Contactanos />} />
                  </Routes>
                </BrowserRouter>
        </div>
      </HelmetProvider>
    </AppContext.Provider>


  );
}

